export const BasePaths = {
  MAIN: "/app",
};
export const PublicPaths = {
  HOME: "/",
  LOGIN: "/",
  FORGOT_PASSWORD: "/forgot-Password",
  RESET_PASSWORD: "/reset-Password/:id",
  REGISTER: "/create-account",
};

export const PrivatePaths = {
  DASHBOARD: "/app/dashboard",
};

export const AdminPrivatePaths = {
  DASHBOARD: "/app/dashboard",
};
